export const educationData = [
    {
        id: 1,
        institution: 'Jaypee University of Engineering and Technology',
        course: 'Bachelors of Technology',
        startYear: '2019',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'St. Gregories Sr. Sec. School',
        course: 'XII CBSE Boards',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'St. Gregories Sr. Sec. School',
        course: 'X CBSE Boards',
        startYear: '2016',
        endYear: '2017'
    },
]